import { render } from "./employee-dashboard.vue?vue&type=template&id=4e16d5cf&scoped=true"
import script from "./employee-dashboard.vue?vue&type=script&lang=js"
export * from "./employee-dashboard.vue?vue&type=script&lang=js"

import "./employee-dashboard.vue?vue&type=style&index=0&id=4e16d5cf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e16d5cf"]])

export default __exports__